module.exports = __webpack_public_path__ + "media/images/default/pages/about/wave-white-13536a7ce977811d2520e738522ec5aa.svg";